<template>
    <div>
        <div class="md:flex space-y-3 md:space-y-0 md:space-x-3 mt-4">
            <select v-model="filtrKemp" @change="zmenaFiltr" class="form-select form-control w-full md:w-1/4">
                <option value="">Kemp</option>
                <option v-for="kemp in kempy" :key="kemp.id_kempy" :value="kemp.id_kempy">{{ kemp.nazev }}</option>
            </select>

            <input v-model="filtrObjednavka" @change="zmenaFiltr" type="text" placeholder="Objednávka (ID nebo číslo objednávky, ID platby, jméno, ...)" class="form-input form-control w-full md:w-1/2">

            <select v-model="filtrStav" @change="zmenaFiltr" class="form-select form-control w-full md:w-1/4">
                <option value="">Stav</option>
                <option value="neuhrazena">Neuhrazená</option>
                <option value="uhrazena">Uhrazená</option>
                <option value="storno">Stornovaná</option>
                <option value="refundace">Refundovaná</option>
                <option value="rezervace">Rezervace</option>
                <option value="offline">Offline</option>
                <option value="chyba">Chyba</option>
            </select>
        </div>

        <div class="mt-6 divide-y divide-gray-100 rounded shadow overflow-hidden">
            <div v-for="objednavka in objednavky" :key="objednavka.id" class="flex sm:items-center justify-between md:h-16 px-4 md:px-8 py-4 md:py-0 md:space-x-6 bg-white hover:bg-gray-50 duration-300">
                <div class="flex-1 sm:flex items-center min-w-0">
                    <div class="flex-1 flex items-center min-w-0">
                        <div class="flex-1 md:flex-none min-w-0 md:w-40">
                            <div class="text-15 truncate">{{ objednavka.created_at_format }}</div>
                            <div class="text-13 text-gray-400 truncate">{{ objednavka.kemp.nazev }}</div>
                        </div>

                        <div class="flex-none w-20 md:w-24 ml-2 sm:ml-4 md:ml-8">
                            <div class="text-15 truncate">ID {{ objednavka.id_objednavky ? objednavka.id_objednavky : objednavka.id_rezervace }}</div>
                            <div class="text-13 text-gray-400 truncate">{{ objednavka.cislo_smlouvy }}</div>
                        </div>

                        <div class="flex-1 hidden md:flex items-center ml-4 md:ml-8">
                            <div class="flex-none w-4 h-4 overflow-hidden rounded-full">
                                <img :src="'/lang/' + objednavka.jazyk.iso + '.svg'" :alt="objednavka.jazyk.iso" class="w-4.5 h-4.5 -my-0.25 object-cover">
                            </div>

                            <div class="flex-1 ml-2">
                                <div class="text-15 truncate">{{ [objednavka.jmeno, objednavka.prijmeni].filter((item) => (item.length > 0) && (item !== '-')).join(' ') }}</div>
                                <div class="text-13 text-gray-400 truncate">{{ [objednavka.ulice, objednavka.mesto].filter((item) => (item.length > 0) && (item !== '-')).join(', ') }}</div>
                            </div>
                        </div>

                        <div class="flex-none hidden sm:block ml-2 sm:ml-4 md:ml-4 text-right">
                            <div v-if="objednavka.stav !== 301" class="text-15 truncate">{{ mena(objednavka.celkem) }} {{ objednavka.mena.zkratka }}</div>
                            <div v-else class="text-13 italic text-gray-400 truncate">nepřenáší se</div>
                            <div v-if="objednavka.stav !== 301" class="text-13 text-gray-400 truncate">{{ mena(objednavka.zaloha) }} {{ objednavka.mena.zkratka }}</div>
                        </div>
                    </div>

                    <div class="flex-none sm:w-28 sm:ml-4 md:ml-8 mt-3 sm:mt-0">
                        <div v-if="objednavka.stav_popis === 'neuhrazena'" class="inline-flex px-3 py-1 text-13 text-center bg-yellow-100 rounded-full">
                            <div class="text-yellow-800">Neuhrazená</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'uhrazena'" class="inline-flex px-3 py-1 text-13 text-center bg-green-100 rounded-full">
                            <div class="text-green-800">Uhrazená</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'storno'" class="inline-flex px-3 py-1 text-13 text-center bg-gray-100 rounded-full">
                            <div class="text-gray-800">Stornovaná</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'refundace'" class="inline-flex px-3 py-1 text-13 text-center bg-orange-100 rounded-full">
                            <div class="text-orange-800">Refundovaná</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'rezervace'" class="inline-flex px-3 py-1 text-13 text-center bg-purple-100 rounded-full">
                            <div class="text-purple-800">Rezervace</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'offline'" class="inline-flex px-3 py-1 text-13 text-center bg-cyan-100 rounded-full">
                            <div class="text-cyan-800">Offline</div>
                        </div>

                        <div v-else-if="objednavka.stav_popis === 'chyba'" class="inline-flex px-3 py-1 text-13 text-center bg-red-100 rounded-full">
                            <div class="text-red-800">Chyba</div>
                        </div>
                    </div>
                </div>

                <div class="flex-none">
                    <a :href="'/admin/objednavky/' + objednavka.id" class="block p-1 md:p-2 -mr-1 md:-mr-2 text-gray-300 hover:text-gray-400 duration-300">
                        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <div slot="no-more"></div>

            <div slot="no-results">
                <p class="mt-4 text-left">Nebyl nalezen žádný záznam</p>
            </div>
        </infinite-loading>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
    components: {
        InfiniteLoading,
    },

    props: {
        kempy: Array,
        kempInit: String,
        stavInit: String,
        objednavkaInit: String,
    },

    data: function () {
        return {
            objednavky: [],
            page: 1,
            filtrStav: this.stavInit,
            filtrKemp: this.kempInit,
            filtrObjednavka: this.objednavkaInit,
            infiniteId: +new Date(),
        }
    },

    methods: {
        infiniteHandler($state) {
            axios.get('/admin/objednavky/fetch', {
                params: {
                    page: this.page,
                    kemp: this.filtrKemp,
                    stav: this.filtrStav,
                    objednavka: this.filtrObjednavka,
                },
            }).then(response => {
                const data = response.data;

                if (data.length) {
                    this.page += 1;
                    this.objednavky.push(...data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },

        zmenaFiltr() {
            this.page = 1;
            this.objednavky = [];
            this.infiniteId += 1;
        },

        mena(castka) {
            return castka.toLocaleString('cs-CZ');
        },
    },
}
</script>
